import mutations from './mutations';
import actions from './actions';

const initialState = {
  loading: false,
  items: []
};

const tenants = {
  namespaced: true,
  state: { ...initialState },
  mutations,
  actions,
  getters: {}
};

export default tenants;
